import {Repository} from '@/repositories/Base/Repository'

class ExamResultRepository extends Repository {
    endpoint = 'mapping/exams_result/observation'

}

export default new ExamResultRepository()
